import { Box, makeStyles, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { IAgentDebtor } from '../../../models/AgentInquiry/IAgentDebtor';
import { ITransactionHistory } from '../../../models/Inquiry/TransactionHistory/ITransactionHistory';
import { useGlobalState } from '../../../store/GlobalStore';

const useStyles = makeStyles((theme) => ({
    root: {
        border: "2px solid black",
        borderRadius: 8,
        height: "90%",
        marginTop: "7px"
    },
    boxView: {
        margin: '0px',
        color: "blue"
    },
    norecord: {
        color: "red",
        fontSize: 15
    },
    history: {
        color: "#009900",
        fontSize: 14
    }
}))

const TransactionAuditHistory: React.FC<{ debtors: IAgentDebtor, transactions: ITransactionHistory[], mapped: boolean }> = (props) => {
    const { transactions, mapped } = props;
    const classes = useStyles();
    const { state } = useGlobalState();
    const [DefaultMapped, setDefaultMapped] = useState(false);

    useEffect(() => {
        if (mapped === false) {
            setDefaultMapped(false)
        }
        else {
            setDefaultMapped(true)
        }
    }, [DefaultMapped])

    // Inspired by the microsoft spinners.
    const useProgressStyles = makeStyles((theme) => ({
        root: {
            position: 'relative',
        },
        bottom: {
            color: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
        },
        top: {
            color: '#1a90ff',
            animationDuration: '550ms',
            position: 'absolute',
            left: 0,
        },
        circle: {
            strokeLinecap: 'round',
        },
    }));

    function Progress(props) {
        const classes = useProgressStyles();
        return (
            <div className={classes.root}>
                <CircularProgress
                    variant="determinate"
                    className={classes.bottom}
                    size={30}
                    thickness={4}
                    {...props}
                    value={100}
                />
                <CircularProgress
                    variant="indeterminate"
                    disableShrink
                    className={classes.top}
                    classes={{
                        circle: classes.circle,
                    }}
                    size={30}
                    thickness={4}
                    {...props}
                />
            </div>
        );
    }

    return (
        <React.Fragment >
            <h4 className={classes.boxView}> Transactions</h4>
            <Box p={1} width="100%" flexShrink={0} bgcolor="white" className={classes.root} >
                <Scrollbars autoHide
                    autoHideTimeout={1000}
                    autoHideDuration={10}
                    autoHeight
                    autoHeightMin={140}
                    autoHeightMax={140}
                    style={{ width: "100%" }}>
                    {mapped ?
                        transactions.map((transactionsHistories) => {
                            if (transactionsHistories.activityType !== "0") {
                                return (
                                    < Typography gutterBottom className={classes.history}>
                                        <p>
                                            {moment(transactionsHistories.activityDt).format(state.GlobalUtils?.settingValue)}
                                            &nbsp;{transactionsHistories.activity}
                                        </p>
                                    </Typography>
                                )
                            }
                            else {
                                return (
                                    < Typography variant="h6" gutterBottom className={classes.norecord}>
                                        No Records to Display
                                    </Typography>)
                            }
                        })
                        : <Progress />
                    }
                </Scrollbars>
            </Box>
        </React.Fragment>
    )
}

export default TransactionAuditHistory
